Namespace 'Customer.Filters'

class Customer.Filters.KeywordsCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/interactions/keywords_card']
  className: 'filter-field-container filter-keyword-container'

  initialize: ({newQuery}) ->
    @newQuery = newQuery

  render: ->
    @$el.html @template
    @_renderKeywordsFilter()
    @

  onApply: ->
    @keywordsFilterView.onApply()

  _renderKeywordsFilter: ->
    @keywordsFilterView = new Customer.Filters.KeywordsFilterView
      searchQuery: @newQuery
      blockChangeEvent: true
    @$el.find('#keyword_filter').html(@keywordsFilterView.render().el)
